export default __webpack_public_path__ + "static/media/volume-tracker.e151b273.svg";